var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCameraWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 21,
    viewBox: "0 0 26 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0938 1H10.1562L7.1875 4.5625H3.625C2.99511 4.5625 2.39102 4.81272 1.94562 5.25812C1.50022 5.70352 1.25 6.30761 1.25 6.9375V17.625C1.25 18.2549 1.50022 18.859 1.94562 19.3044C2.39102 19.7498 2.99511 20 3.625 20H22.625C23.2549 20 23.859 19.7498 24.3044 19.3044C24.7498 18.859 25 18.2549 25 17.625V6.9375C25 6.30761 24.7498 5.70352 24.3044 5.25812C23.859 4.81272 23.2549 4.5625 22.625 4.5625H19.0625L16.0938 1Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.125 15.25C15.0925 15.25 16.6875 13.655 16.6875 11.6875C16.6875 9.71999 15.0925 8.125 13.125 8.125C11.1575 8.125 9.5625 9.71999 9.5625 11.6875C9.5625 13.655 11.1575 15.25 13.125 15.25Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraWhite);
export default __webpack_public_path__ + "static/media/camera_white.82d53c0a64d6364be986e1983b579d35.svg";
export { ForwardRef as ReactComponent };